import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Table, Button, FormGroup} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {Typeahead} from 'react-bootstrap-typeahead';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import Inputmask from 'inputmask';
import {lock} from 'react-icons-kit/icomoon/lock';
import {unlocked} from 'react-icons-kit/icomoon/unlocked';
import ModalAuth from '../unitReserve/modalAuth';
import {ic_print} from 'react-icons-kit/md/ic_print';
import WaitingModal from '../../generics/WaitingModal';
import ModalFolioSend from './modalFolioSend';
import ModalReport from './modalReport';
import {print} from 'react-icons-kit/fa/print';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import ModalDataSend from './modalDataSend';
import ModalExpiration from './ModalExpiration';
import $ from 'jquery';

var Config = require('../../../config');
var pantalla = "";

class UnitSend extends Component{
	constructor(props){
		super(props);

		this.onCancel = this.onCancel.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.getHealthFacilities = this.getHealthFacilities.bind(this);
		this.saveAuth = this.saveAuth.bind(this);
		this.updateTables = this.updateTables.bind(this);
		this.addToList = this.addToList.bind(this);
		this.addByKey = this.addByKey.bind(this);
		this.getUnits = this.getUnits.bind(this);
		this.removeUnitSent = this.removeUnitSent.bind(this);
		this.printFolio = this.printFolio.bind(this);
		this.printReport = this.printReport.bind(this);
		this.selectFolio = this.selectFolio.bind(this);
		this.addProduct = this.addProduct.bind(this);
		this.validate = this.validate.bind(this);
		this.onSendProduct = this.onSendProduct.bind(this);
		this.getReserves = this.getReserves.bind(this);
		this.getReservedProducts = this.getReservedProducts.bind(this);
		this.getSendProducts = this.getSendProducts.bind(this);
		this.saving = this.saving.bind(this);
		this.printLabelAll = this.printLabelAll.bind(this);
		this.addIsogrupo = this.addIsogrupo.bind(this);
		this.setDataValidate = this.setDataValidate.bind(this);

		this.state = {
			show: false,
			table_reserve: [],
			petition_id:"",
			units_list: [],
			table_units:[],
			received_by:"",

			unit_number:"",
			unit_reserved_id:"",
			health_facilities: [],
			facility_sections_id:"",
			date:"",
			hour:"",
			group:"",
			rh:"",
			compatible:"",
			group_rh:"",

			id:"",
			petition_id:"",
			register_date:"",
			register_hour:"",
			samples_id:"",
			cross_technique_flag:"",
			cross_technique:"",
			unit_reserved_parts:[],
			component_selected:{},
			unit_reserved_id:"",
			preview_print:{},

			plasmatic_product_id:"",
			lot_number:"",
			amount:"",
			products:[],
			loading_product:false,
			product_selected:[],
			index_product:-1,
			valid_prod:"",
			pat_aut_print_delivered:{},
			reserves:[],
			pat_res_to_send:{},
			pat_notif_del_ehcos:{},
			pat_change_date_delivery:{},
			save:true,
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);

				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});

		if(this.props.match.path.indexOf('send_products') !== -1){
			pantalla = 'products';

			fetch(Config.default.apiGateway.URL+'plasmatic_product/stock_by_lot/'+
				sessionStorage.getItem('health_facilities_id'),{
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({products:response});
				}
			});

			this.setState({petition_id:this.props.match.params.id});
		}else{
			pantalla = '';
		}

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		if(this.props.socket.readyState !== this.props.socket.OPEN){
			//this.props.socket.send("initfp");
		}


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		var id = this.props.match.params.id;

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_CHANG_DATE_DELIVERY',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_change_date_delivery: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_RES_TO_SEND',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_res_to_send: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_AUT_PRINT_DELIVERED',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_aut_print_delivered: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_NOTIF_DEL_EHCOS',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_notif_del_ehcos: response
			});
		})

		this.props.waiting.handleShow('Cargando...');

		//fecha y hora
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);
			var aux_date = new Date();

			this.setState({
				date : moment(aux[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
				hour:hours,
			});
		});

		if(this.props.match.path.indexOf('send_products') === -1){
			this.getReserves(id);
			this.getHealthFacilities();
			this.getUnits();
		}else{
			this.getReservedProducts(id);
			this.getSendProducts(id);
		}
			
	}

	getUnits(){
		var id = this.props.match.params.id;
		fetch(Config.default.apiGateway.URL+'unit_delivered/by_petition?id='+id+
			'&hf_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.setState({
					group:response.patient_group,
					rh:response.patient_rh,
					patient:response.patient_name,
					petition:response.petition_group_type,
					no_file: response.expedient,
					group_rh: (response.patient_group !== null ? response.patient_group : '')+
						(response.patient_rh === 'POSITIVO' ?
							'+'
						:response.patient_rh === 'NEGATIVO' ?
							'-'
						: ''),
					table_units:[]
				});

				response.units_delivered.map((res, i)=>{
					
					this.setState({
						table_units: [
							...this.state.table_units,
							{
								folio:res.folio,
								unit_id:res.unit.id,
								unit: res.unit.unit_number,
								code:res.code,
								component: res.component,
								component_number: res.unit.component_number,
								volume:res.unit.volume,
								received_by: res.received_by,
								facility_sections_name: res.facility_section,
								delete: false,
								id:res.unit_delivered_id,
								date_time:moment(res.register_date).format('DD/MM/YYYY')+' '+moment(res.register_hour, 'H:mm:ss').format('HH:mm'),
								refund_date:res.refund_date
							}
						],
					});

				})

				var index = this.state.health_facilities.findIndex(obj =>
					obj.name === response.health_services
				)

				/*if(origen === 'save'){
					var last_id = response.units_delivered[response.units_delivered.length - 1].unit_delivered_id;
					
					this.printLabel('', last_id);
				}*/
					

				this.setState({
					petition_id:id,
					facility_sections_id: index !== -1 ? this.state.health_facilities[index].key : ''
				});		
			}
		});
	}

	getReserves(id){
		fetch(Config.default.apiGateway.URL+'unit_reserved/by_petition?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				this.updateTables(response);
				this.setState({reserves:response});

				//this.setState({petition_id:id, unit_reserved_id:response.unit_reserved.id, unit_reserved_id:response.unit_reserved.id});
			}
		});	
	}

	getReservedProducts(id){
		fetch(Config.default.apiGateway.URL+'petitions/get_products/'+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				this.setState({table_reserve:response.product_list});
			}
		});	
	}

	getSendProducts(id){
		fetch(Config.default.apiGateway.URL+'plasmatic_product_export/petition_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				response.map((r)=>{
					this.setState({
						table_units: [...this.state.table_units, {
							id: r.export.id,
							plasmatic_product_id:r.product.id,
							name: r.product.name,
							lot_number: r.export.lot_number,
							amount: r.export.amount,
							delivered_to: r.export.delivered_to
						}]
					});
				})
			}
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;
		var value = e.target.value;

		if(campo === 'received_by'){
			if(value.length <= 120){
				this.setState({
					[e.target.name]: e.target.value
				});	
			}
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}
		

		if(value !== ""){
			//setTimeout(()=>{
				document.getElementById(e.target.id).classList.remove("error");
			//}, 500);
		}

		if(e.target.name === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}
	}
	
	searchComponent(e){
		
		if(e.key === 'Enter'){
			e.preventDefault();

			if(this.state.unit_number !== ""){
				this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'unit_reserved/by_unit_number?petition_id='+
					this.state.petition_id+'&unit_number='+this.state.unit_number+'&hf_id='+sessionStorage.getItem("health_facilities_id"),{
					method: 'GET',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						response.map((res)=>{
							res.label = res.component.code+' '+res.unit.component_number
						});
						this.setState({
							units_list: response
						});

						setTimeout(()=>{
							this._typeahead.getInstance().focus();
						}, 500)
						
					}
				});
			}else{
				swal('Error', 'Debe de ingresar un numero de unidad', 'error');
			}
		}
	}

	//get healt facilities
	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'lookups?type=SHIPPING_DESTINATIONS&option=actives&order=true',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      health_facilities: response
		    });
			
		})
	}

	onCancel(){
		this.props.history.push('/petition_register');
	}

	onChange(e){
		if(e.length > 0){
			document.getElementById('received_by').classList.remove('error');
			this._typeahead.getInstance().focus();

			var index = this.state.table_units.findIndex(obj => 
				(obj.refund_date === null || obj.refund_date === undefined) && obj.unit_id === e[0].unit.id
			);

			if(index === -1){
				if(e[0].unit_status !== 'BLOQUEADA'){
					this.setState({
						component_selected:{
							unit_id:e[0].unit.id,
							unit: e[0].unit.unit_number,
							component: e[0].component.component,
							component_number: e[0].unit.component_number,
							delete: true,
							facility_sections_name:"",
							received_by: "",
							volume:e[0].unit.volume,
							unit_group:e[0].unit.group,
							unit_rh:e[0].unit.rh,
						},
						
						isLoading: false,
					});

					setTimeout(()=>{
						this.addToList();
					}, 500);
				}else{
					swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
					this._typeahead.getInstance().blur();
					this._typeahead.getInstance().clear();
					this._typeahead.getInstance().focus();
				}

					
					
								
			}else{
				this._typeahead.getInstance().clear();
				this.setState({
					unit_number:"",
					units_list:[],
					component_selected:{},
				});
				swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
			}
			
		}
	}

	ValidateCompatibility(e, unit){
		if(unit.unit_id!==undefined){
			var error = false;

			console.log(this.state.group, this.state.rh)
			if(this.state.group === "" && this.state.rh === ""){
				error = true;			

				if(this.state.petition === 'URGENT_COMPONENTS'){
					error = false;
				}
			}
			if(!error){
				var group = this.state.group
				var rh = this.state.rh;

				this.props.waiting.handleShow('Verificando...');
				fetch(Config.default.apiGateway.URL+'compatibility_groups/compare?patient_group='+group+
					'&patient_rh='+rh+'&unit_id='+unit.unit_id,{
					method: 'GET',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						})
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							compatible: response
						});

						setTimeout(()=>{
							this._typeahead.getInstance().clear();
							document.getElementById('unit_number').focus();

							
							if(this.state.compatible !== ""){
								setTimeout(()=>{
									if(this.state.compatible !== 'INCOMPATIBLE'){
										this.setDataValidate(e, group, rh, unit);
											
									}else{
										if(this.state.petition === 'URGENT_COMPONENTS'){
											this.setDataValidate(e, group, rh, unit);
										}else{
											swal('Error', 'La unidad no puede ser agregada debido a que es incompatible', 'error');
										}
									}
								}, 500);
							}
								
						}, 500);
					
					}
				});
			}else{
				swal('Error', 'El paciente debe tener asignado Grupo & RH', 'error');
			}
		}else{
			swal({
				title: 'Error',
				text: 'Debe seleccionar un numero de unidad',
				type: 'error',
				closeOnConfirm: true
			}, (isConfirm)=> {

				if(isConfirm){
					setTimeout(()=>{
						document.getElementById('unit_number').focus();
					}, 500);
					
				}
				
			})	
		}
	}

	setDataValidate(e, group, rh, unit){
		if(this.state.compatible === 'URGENCIA TRANSFUSIONAL'){
			var index = this.state.reserves.findIndex(obj => 
				obj.unit_reserved.unit_id === this.state.component_selected.unit_id
			)
			if(index !== -1){
				if(this.state.reserves[index].unit_reserved.require_authorization){
					this.viewAuth(e, this.state.component_selected.unit_id, 'select');
				}else{
					this.state.component_selected.facility_sections_name = this.state.facility_sections_id;
					this.state.component_selected.received_by = this.state.received_by;
					
					this.setState({
						table_units: [
							...this.state.table_units,	this.state.component_selected
						],
						isLoading: false,
						unit_number:"",
						units_list:[],
						component_selected:{},
						save:false
					});
				}
			}else{
				this.viewAuth(e, this.state.component_selected.unit_id, 'select');
			}
			
		}else{
			if(group+' '+rh !==  unit.unit_group+' '+unit.unit_rh && this.state.petition !== 'URGENT_COMPONENTS'){
				this.addIsogrupo();
			}else{
				this.state.component_selected.facility_sections_name = this.state.facility_sections_id;
				this.state.component_selected.received_by = this.state.received_by;
				
				this.setState({
					table_units: [
						...this.state.table_units,	this.state.component_selected
					],
					isLoading: false,
					unit_number:"",
					units_list:[],
					component_selected:{},
					save:false
				});
			}
				

		}
	}

	handleSearch = (query) => {
	    this.setState({isLoading: true});
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.table_units];
		array.splice(indice, 1);
		this.setState({table_units: array});
	}

	checkExpiration(obj){
		fetch(Config.default.apiGateway.URL+'petitions/is_expired?petition_id='+this.state.petition_id,{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				if(response){
					this.modal_expiration.handleShow(obj);
				}else{
					this.saving(obj);
				}
				
			}
				
		});
	}

	saving(obj){
		this.props.waiting.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+'unit_delivered',{
			method: 'post',
			body: JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				swal("Correcto", "Registro guardado correctamente.", 'success');
				//this.props.history.push('/petition_register');
				if(this.state.pat_notif_del_ehcos.value === 'YES'){
					this.modal_data.handleShow(response.xmls);
				}

				if(pantalla !== 'products'){
					if(this.state.pat_aut_print_delivered.value === 'YES'){
						
						this.printLabelAll('', response.unit_delivered_ids);
					}
				}

				this.setState({save:true});
				
				this.getUnits();
			}
				
		});	
	}

	onSave(){
		var date = moment(this.state.date);
		var hour = moment(this.state.hour, 'h:mm a');

		if(date.format('MM-DD-YYYY') === 'Invalid date'){
			notify.show('Error, Fecha invalida', 'error');

		}else if(this.state.hour.indexOf('-') !== -1){
			notify.show('Error, Hora invalida', 'error');

		}else{

			if(this.isValidForm()){
				if(this.state.table_units.length > 0){
					this.setState({save:true});

					var units = [];
					this.state.table_units.map((u, i)=>{
						if(u.delete){
							units.push({
								unit_id: u.unit_id,
								facility_section: u.facility_sections_name,
								register_date: date.format('MM-DD-YYYY'),
								register_hour: hour.format('H:mm'),
								received_by: u.received_by,
							});
						}
						
					});

					var obj = {};
					obj = {
						petition_id: parseInt(this.state.petition_id, 10),
						items: units
					}

					var send = false;
					this.props.task_has_user_profiles.map((user)=>(
						user !== undefined ?
				        	user === "SEND_EXPIRED_UNIT_PAT" ? 
								send = true
							: null
				      	:null
			    	))

			    	if(send){
			    		this.checkExpiration(obj)
			    	}else{
			    		this.saving(obj);
			    	}
					

				}else{
					swal('¡El registro no se puede agregar!', '¡Ingrese una unidad !', 'error');
				}
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}	
		}
	}

	printLabelAll(e, ids){
		if(e !== ''){
			e.preventDefault();
		}

		this.props.waiting.handleShow('Imprimiendo...');
          
		var obj ={};

		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.array_ids = ids
		obj.file_type = "label_send_comp";
		obj.nEtiqueta = [];
		fetch(Config.default.apiGateway.URL+'labelsEditor', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		}).then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO" && this.state.pat_aut_print_delivered.value === 'NO'){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else if(this.state.preview_print.value === "NO" && this.state.pat_aut_print_delivered.value === 'YES'){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else if(this.state.preview_print.value === "YES" && this.state.pat_aut_print_delivered.value === 'YES'){
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=> {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_send_comp", "File": "'+aux[1]+'"}');
					}
				}else if(this.state.preview_print.value === "YES" && this.state.pat_aut_print_delivered.value === 'NO'){
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=> {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_send_comp", "File": "'+aux[1]+'"}');
					}
				}

			}
		});
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
    			const isInputValid = this.showCtrlError(input.name);
    			
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}	   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			
			if(this.state[refName] !== undefined){
				
				if(this.state[refName] === ""){
					
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
						
					}
					res = true;
				}
			}else{
				
				
				if(control.value === ""){
					
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
						
					}
					res = true;
				}
			}
		}
		

		return res;
	}

	viewAuth(e, id, type){
		this.modal_auth.handleShow(id);
	}

	saveAuth(id){
		var index = this.state.reserves.findIndex(obj => 
			obj.unit_reserved.unit_id === id
		)

		var method = '';
		var api = '';

		if(index !== -1){
			var reserve = this.state.reserves[index];

			var obj = {
				id:reserve.unit_reserved.id,
				petition_id: reserve.unit_reserved.petition_id,
				register_date:reserve.unit_reserved.register_date,
				register_hour:reserve.unit_reserved.register_hour,
				cross_technique_flag:reserve.unit_reserved.cross_technique_flag ,
				cross_technique:reserve.unit_reserved.cross_technique,
				samples_id:reserve.unit_reserved.samples_id,
				unit_id:id,
				petition_blood_component_id: null,
				require_authorization:false,
				sample_is_expired: reserve.unit_reserved.sample_is_expired,
				compatibility: reserve.unit_reserved.compatibility,
			}

			method = 'PUT';
			api = 'unit_reserved/'+obj.id;
			
			obj.timestamp = moment(this.state.date+' '+this.state.hour).format('YYYY-MM-DDTHH:mm:ss');
			
		}else{
			var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
			var hour = moment(this.state.hour, 'h:mm a');
			var obj = {
				petition_id: this.state.petition_id,
				register_date:this.state.register_date,
				register_hour:this.state.register_hour,
				cross_technique_flag:this.state.cross_technique_flag ,
				cross_technique:this.state.cross_technique,
				samples_id:this.state.samples_id,
				unit_id:id,
				petition_blood_component_id: null,
				require_authorization:false,
				compatibility: this.state.compatible,
			}

			method = 'POST';
			api = 'unit_reserved';
			
		}

		

		fetch(Config.default.apiGateway.URL+api,{
			method: method,
			body: JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					table_units: [
						...this.state.table_units,	this.state.component_selected
					],
					isLoading: false,
					unit_number:"",
					units_list:[],
					component_selected:{},
				});
			}
		});
	}

	updateTables(response){	
		response.map((res, i)=>{
			this.setState({
				id:res.unit_reserved.id,
				petition_id:res.unit_reserved.petition_id,
				register_date:res.unit_reserved.register_date,
				register_hour:res.unit_reserved.register_hour,
				samples_id:res.unit_reserved.samples_id,
				cross_technique_flag:res.unit_reserved.cross_technique_flag,
				cross_technique:res.unit_reserved.cross_technique,
				unit_reserved_parts:res.unit_reserved_parts,
			});

			this.setState({
				table_reserve: [
					...this.state.table_reserve,
					{
						unit_id:res.unit.id,
						date:moment(res.unit_reserved.register_date).format('DD/MM/YYYY')+' '+
							moment(res.unit_reserved.register_hour, 'H:mm:ss').format('HH:mm'),
						unit: res.unit.unit_number,
						group_rh: res.group+res.rh,
						component: res.blood_component.component,
						component_number: res.unit.component_number,
						compatibility: res.unit_reserved.compatibility,
						require_authorization: res.unit_reserved.require_authorization,
						status:res.status
					}
				],
			});
		});
	}

	addByKey(e){
		if(e.key === 'Enter'){
			this.ValidateCompatibility(e,this.state.component_selected.unit_id);				
		}
	}

	addToList(e){
		if(this.state.component_selected.unit_id !== undefined){
			if(this.state.facility_sections_id !== null && this.state.facility_sections_id!==""){
				this._typeahead.getInstance().clear();
				this.ValidateCompatibility(e, this.state.component_selected);
			}
			else{
				swal('Error', 'Debe ingresar el destino de la unidad', 'error');
				document.getElementById('facility_sections_id').classList.add("error");
			}
		}else{
			if(this.state.unit_number === ""){
				swal('Error', 'Debe ingresar un numero de unidad', 'error');
				document.getElementById('unit_number').classList.add("error");
			}
			
		}			
	}

	selectFolio(e){
		e.preventDefault()
		this.modal_folio.handleShow(this.props.match.params.id);
	}

	printReport(e){
		e.preventDefault();
		this.modal_report.handleShow(this.state.table_units);
	}

	removeUnitSent(e, id){
		e.preventDefault();
		swal({
			title: '¿Está seguro?',
			text: '¿Desea eliminar esta unidad?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_delivered/'+id,{
					method:'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getUnits();
					}
				})	
			}
		});
	}

	async printFolio(e, folio){
		e.preventDefault();

		this.props.waiting.handleShow('Imprimiendo...');
          
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = folio
		obj.file_type = "transfusion_unit";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({ show: false});
		}else{
			this.props.waiting.handleClose();
		}
	}

	printLabel(e, id){
		if(e !== ''){
			e.preventDefault();
		}

		this.props.waiting.handleShow('Imprimiendo...');
          
		var obj ={};

		obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
		obj.id = id
		obj.file_type = "label_send_comp";
		obj.nEtiqueta = [];
		fetch(Config.default.apiGateway.URL+'labelsEditor', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		}).then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO" && this.state.pat_aut_print_delivered.value === 'NO'){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else if(this.state.preview_print.value === "NO" && this.state.pat_aut_print_delivered.value === 'YES'){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else if(this.state.preview_print.value === "YES" && this.state.pat_aut_print_delivered.value === 'YES'){
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=> {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_send_comp", "File": "'+aux[1]+'"}');
					}
				}else if(this.state.preview_print.value === "YES" && this.state.pat_aut_print_delivered.value === 'NO'){
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=> {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_send_comp", "File": "'+aux[1]+'"}');
					}
				}

			}
		});
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'product'){
        		this.setState({loading_product:true});

        		setTimeout(()=>{
        			this.setState({
						index_product:0,
						product_selected:values,
						amount:1,
						cost_unit_entry:values[0].cost_unit,
						loading_product:false,
						plasmatic_product_id:values[0].id,
						valid_prod: '',
						lot_number:values[0].lot_number
				    });

				    this._typeahead_product.getInstance().blur();
				    document.getElementById('lot_number').focus();

				    this.errorAutoComplete('product');
				    this.validate('details')

        		}, 1000);
	        		
        	}
        	
        }
    }

    errorAutoComplete(name){
		const length = name === 'product' ? this.state.plasmatic_product_id.length :  this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='product'){
				this.setState({valid_prod:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='product'){
				this.setState({valid_prod:''});
			}

		}
	
		return isFormValid;
	}

	onSendProduct(e){
		if(this.validate('despatch')){
			if(this.state.table_units.length > 0){

				var obj = {
					petition_id:this.state.petition_id,
					date:moment(this.state.date, 'YYYY-MM-DD').format('MM-DD-YYYY'),
					hour:moment(this.state.hour, 'HH:mm').format('H:mm:ss'),
					products:[]
				}

				this.state.table_units.map((t)=>{
					if(t.id === ''){
						obj.products.push({
							product_id:t.plasmatic_product_id,
							lot_number:t.lot_number,
							amount:t.amount,
							delivered_to:this.state.received_by,
						})
					}
						
				})

				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+'plasmatic_product_export/'+
					sessionStorage.getItem('health_facilities_id'),{
					method: 'post',
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return 'ok';
					}
				}).then(response => {
					if(response !== undefined){
						swal('Proceso Terminado', 'El envio se realizó correctamente', 'success');
						this.props.history.push('/petition_register');
					}
				})

			}else{
				swal('Error', 'Debe de agregar por lo menos un producto', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	addProduct(e){
  		if(this.validate('details')){
  			if(this.state.product_selected[0].total < parseInt(this.state.amount)){
  				swal('Error', 'El producto no cuenta con stock suficiente, el stock disponible es de: '+this.state.product_selected[0].total, 'error');
  			}else{
  				var index = this.state.table_units.findIndex(obj => 
	  				obj.plasmatic_product_id === this.state.plasmatic_product_id &&
	  				obj.lot_number === this.state.lot_number
	  			);

	  			if(index === -1){
	  				this.setState({
		  				table_units:[
		  					...this.state.table_units,
		  					{
		  						id:"",
		  						plasmatic_product_id:this.state.plasmatic_product_id,
		  						name:this.state.product_selected[0].name,
								lot_number:this.state.lot_number,
								amount:this.state.amount,
								delivered_to:this.state.received_by,

		  					}
		  				],

		  				plasmatic_product_id:"",
						lot_number:"",
						amount:"",
						loading_product:false,
						product_selected:[],
						index_product:-1,
						valid_prod:"",
						save:false
		  			});
	  			}else{
	  				swal('Error', 'El producto ya se encuentra agregado', 'error');
	  			}
  			}



	  			

	  			
  		}else{
  			swal('Error', 'Campos Incompletos', 'error');
  		}
  	}

	validate(section){
  		const select = document.querySelector('div.'+section);
   		const inputs = select.querySelectorAll('input,select');
   		let isFormValid = true;

   		inputs.forEach(input => {
	    	if(input.required){
    			if(input.id === 'product'){
	    			isFormValid = this.errorAutoComplete(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}   
		  	}
	    });
	    
	    return isFormValid;
  	}

  	addIsogrupo(){
		swal({
			title: '¿Unidad a ISO GRUPO?',
			text: '¿Desea agregar esta unidad?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Agregar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				setTimeout(()=>{
					this.state.component_selected.facility_sections_name = this.state.facility_sections_id;
					this.state.component_selected.received_by = this.state.received_by;
					
					this.setState({
						table_units: [
							...this.state.table_units,	this.state.component_selected
						],
						isLoading: false,
						unit_number:"",
						units_list:[],
						component_selected:{},
						save:false
					});
				}, 500)
			}else{
				setTimeout(()=>{
					this.setState({
						isLoading: false,
						unit_number:"",
						units_list:[],
						component_selected:{},
					})
					document.getElementById('unit_number').focus();
					this._typeahead.getInstance().clear();
				}, 500)
			}
		});
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
          				{pantalla === 'products' ? 'Entrega de productos' : 'Entrega de Unidades'}
					</h5>
				</div>
				<form noValidate>
					
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Número de Expediente</span>
						</div>
						<div className="col-xs-12 col-sm-9">
							<span className="color-font">{this.state.no_file}</span>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right", marginTop:"10px"}}>
							<span className="span-min">Nombre de Paciente</span>
						</div>
						<div className="col-xs-12 col-sm-6">
							<span className="color-font" style={{marginRight:"20px"}}>{this.state.patient}</span>

							<span style={{color:"red", fontWeight:"bold", fontSize:"25px"}}>{this.state.group_rh}</span>
						</div>
					</div>

	        		<div className="col-xs-12" >
		        		{this.state.petition !== 'URGENT_COMPONENTS' &&
							<fieldset>
								<legend>
									{pantalla === 'products' ? 'Productos solicitados' : 'Unidades Reservadas'}		        				
								</legend>
								<div className={pantalla === 'products' ? "col-xs-12 col-sm-6" : "col-xs-12"}>
									<Table responsive hover>
										<thead>
											
											{pantalla === 'products' ?
												<tr>
													<th>Producto</th>
													<th>Cantidad</th>
												</tr>
											:<tr>
												<th>Fecha</th>
												<th>Unidad</th>
												<th>Grupo RH</th>
												<th>Componente</th>
												<th>Numero Componente</th>
												<th>Autorización</th>
												<th>Estatus</th>
											</tr>}
										</thead>
										<tbody>
											{this.state.table_reserve.map((t, i)=>(
												pantalla === 'products' ?
													<tr key={i}>
														<td>{t.name}</td>
														<td>{t.amount}</td>
													</tr>
												:t.compatibility !== 'INCOMPATIBLE' ?
													<tr key={i}>
														<td>{t.date}</td>
														<td>{t.unit}</td>
														<td>{t.group_rh}</td>
														<td>{t.component}</td>
														<td>{t.component_number}</td>
														<td>
															{t.compatibility === 'URGENCIA TRANSFUSIONAL' ?
																t.require_authorization ?<a href="" onClick={(e) =>this.viewAuth(e, t.unit_id, 'reserva')}>
																	PENDIENTE <SvgIcon icon={lock} style={{cursor:"pointer"}} /></a>
																: <span>AUTORIZADA <SvgIcon icon={unlocked} style={{cursor:"pointer"}}/></span>
															: ''}
														</td>
														<td>{t.status}</td>
													</tr>
												:null
											))}
										</tbody>
									</Table>
								</div>
							</fieldset>
						}
		        		<hr style={{width:"100%"}} />
		        		<fieldset>
		        			<legend>{pantalla === 'products' ? 'Productos' : 'Unidades'}</legend>
			        		<div className="col-xs-12" style={{marginTop: "5px"}}>
			        			<div className="col-xs-12 despatch">
			        				<div className="col-xs-12 col-sm-2" >
			        					<span className="span-min">Fecha</span>
			        					<input type="date" name="date" id="date" value={this.state.date} 
			        						onChange={this.handleChange} className="form-control" required
											disabled={this.state.pat_change_date_delivery.value === 'NO'}/>
			        				</div>
			        				<div className="col-xs-12 col-sm-2">
			        					<span className="span-min">Hora</span>
			        					<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" 
			        						data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
			        						value={this.state.hour || ""} onChange={this.handleChange}
											required className="form-control"
											disabled={this.state.pat_change_date_delivery.value === 'NO'}/>
			        				</div>

			        				<div className="col-xs-12 col-sm-2">
				        				<span className="span-min">Entregado a</span>
				        				<input type="text" className="form-control" name="received_by" 
				        					id="received_by" value={this.state.received_by} onChange={this.handleChange}  />
			        				</div>
			        				{pantalla !== 'products' ?
			        					<div className="col-xs-12 col-sm-2">
				        					<span className="span-min">Destino</span>
				        					<select className="form-control" name="facility_sections_id" id="facility_sections_id"
				        						value={this.state.facility_sections_id} onChange={this.handleChange}>
				        						<option value="">Seleccione...</option>
				        						{this.state.health_facilities.map((h, i)=>{
				        							return <option key={i} value={h.key}>
				        								{h.name}
				        							</option>
				        						})}
				        					</select>
				        				</div>
			        				:null}
				        				
			        			</div>
			        			{pantalla === 'products' ?
			        				<div className="col-xs-12 form-group details">
			        					<div className="col-xs-12 col-sm-2">
											<FormGroup id="valid_prod" validationState={this.state.valid_prod || null} 
												style={{marginBottom:"0px"}}>
												<span className="span-min">Producto</span>
												<Typeahead
										          	labelKey={(option) => (`${option.name+' - lote: '+option.lot_number}`)}
										          	minLength={0}
										          	options={this.state.products.length > 0 ? this.state.products : []}
										          	onChange={this.handleTypeAheadChange('product')}	
										            inputProps={{
										          		name:"product",
										          		id:"product",
										          		autoComplete:"off",
										          		required:true
										          	}}
										          	id="auto_product"
										          	isLoading={this.state.loading_product}
										          	useCache={false}
										          	ref={ref => this._typeahead_product = ref}
										          	defaultSelected={this.state.products.slice(this.state.index_product, 1)}
										          	selected={this.state.product_selected}
										          	selectHintOnEnter={true}
										          	delay={600}
										          	paginationText="Mostrar mas resultados..."
										        />
										    </FormGroup>
										</div>
										<div className="col-xs-12 col-sm-2">
											<span className="span-min">Lote</span>
											<input type="text" className="form-control" name="lot_number" id="lot_number"
												value={this.state.lot_number}
												disabled/>
										</div>

										<div className="col-xs-12 col-sm-1">
											<span className="span-min">Cantidad</span>
											<input type="number" className="form-control hour-input" name="amount" id="amount"
												value={this.state.amount} onChange={this.handleChange} 
												onKeyPress={this.blurInput} required/>
										</div>
										 <div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>
								        	<button type="button" className="btn btn-info" onClick={this.addProduct}  style={{width:'100%'}}>
								        		Agregar
								        	</button>
								        </div>
			        				</div>
			        			:<div className="col-xs-12 form-group" >
			        				<div className="col-xs-12 col-sm-2">
				        				<span className="span-min">Unidad</span>
				        				<input type="text" name="unit_number" id="unit_number" 
				        					value={this.state.unit_number} className="form-control"
				        					onChange={this.handleChange} onKeyPress={this.searchComponent} />
				        				
							        </div>
							        <div className="col-xs-12 col-sm-2">
							        	<span className="span-min">Componente</span>
							        	<Typeahead
								          	labelKey={(option) => `${option.label}`}
								          	minLength={0}
								          	options={this.state.units_list.length > 0 ? this.state.units_list : []}
								          	onChange={this.onChange}
								          	onSearch={this.handleSearch}
								       		//onKeyDown={this.addByKey}
								            inputProps={{
								          		name:"component_number",
								          		id:"component_number"
								          	}}
								          	id="componentNumber"
								          	isLoading={this.state.isLoading}
								          	ref={ref => this._typeahead = ref}
								          	selectHintOnEnter={true}
								          	delay={600}
								          	paginationText="Mostrar mas resultados..."
								        />
							        </div>
							        <div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>
							        	<button type="button" className="btn btn-info" onClick={this.addToList}>
							        		Agregar
							        	</button>
							        </div>
			        			</div>}
			        			
			        		</div>
			        		<div className="col-xs-12">
			        			<Table responsive hover>
			        				<thead>
			        					{pantalla === 'products' ?
			        						<tr>
				        						<th>Producto</th>
				        						<th>Lote</th>
				        						<th>Cantidad</th>
				        						<th>Entregado a</th>
				        						<th></th>
				        					</tr>
			        					:<tr>
			        						<th>Folio</th>
			        						<th>Fecha Hora Envio</th>
			        						<th>Unidad</th>
			        						<th>Volumen</th>
			        						<th>Componente</th>
			        						<th>Numero Componente</th>
			        						<th>Entregado a</th>
			        						<th>Destino</th>
			        						<th style={{textAlign:'center'}}>Etiqueta envio componentes</th>
			        						<th></th>
			        					</tr>}
			        					
			        				</thead>
			        				<tbody>
			        					{this.state.table_units.map((t, i)=>(
			        						pantalla === 'products' ?
			        							<tr key={i}>
			        								<td>{t.name}</td>
					        						<td>{t.lot_number}</td>
					        						<td>{t.amount}</td>
					        						<td>{t.delivered_to}</td>
					        						<td>
					        							{t.id === "" ?
					        								<Button className="btn btn-info btn-xs" title="Eliminar" 
																style={{marginRight:'3px'}} 
																disabled={!this.props.task_unit_delivered.delete}
																onClick={(e) => this.removeUnitFromList(i, e)}>
									                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
									                        </Button>
					        							:null}
					        						</td>
			        							</tr>
			        						: <tr key={i}>
												<td>{t.folio}</td>
												<td>{t.date_time}</td>
												<td>{t.unit}</td>
												<td>{t.volume+' ml.'}</td>
												<td>{t.component}</td>
												<td>{t.component_number}</td>
												<td>{t.received_by}</td>
												<td>{t.facility_sections_name}</td>
												<td style={{textAlign:'center'}}>
													{t.refund_date === null && t.folio !== undefined?
														<SvgIcon icon={priceTag} style={{cursor:"pointer"}} 
															onClick={(e) => this.printLabel(e, t.id)} />
													: null}
												</td>
												<td>
													{t.refund_date === null && t.folio !== undefined?
														<Button className="btn btn-info btn-xs" title="Imprimir" 
															style={{marginRight:'3px'}} 
															onClick={(e) => this.printFolio(e, t.folio)}>
								                            <SvgIcon icon={ic_print} style={{paddingTop:"3px"}}/>
								                        </Button>
													: t.refund_date === undefined ? '' : 'Unidad devuelta'}
												
													{t.refund_date === null ?
														t.delete ?
															<Button className="btn btn-info btn-xs" title="Eliminar" 
																style={{marginRight:'3px'}} 
																disabled={!this.props.task_unit_delivered.delete}
																onClick={(e) => this.removeUnitFromList(i, e)}>
									                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
									                        </Button>
														:
															<Button className="btn btn-info btn-xs" title="Eliminar" 
																style={{marginRight:'3px'}} 
																disabled={!this.props.task_unit_delivered.delete}
																onClick={(e) => this.removeUnitSent(e, t.id)}>
									                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
									                        </Button>
									                : null}
														
												</td>
											</tr>
										))}
			        				</tbody>
			        			</Table>
			        		</div>
			        	</fieldset>

			        	<hr style={{width:"100%"}}/>
			        	{pantalla !== 'products' ?
			        		<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
								<button className="toolIcon" disabled={this.state.table_units.length === 0} 
									onClick={this.printReport}>
									<SvgIcon size={40} icon={print} />
									<div className="col-xs-12">
										<span>Informe</span>
									</div>
								</button>
							</div>
			        	:null}
				        	
						<div className="col-xs-12" style={{textAlign:'center'}}>
				        	<div>
				        		{pantalla !== 'products' ?
									<Button className="btn btn-info btn-xs" title="Imprimir Folio" 
										onClick={(e) => this.selectFolio(e)}
									 	style={{height:'37px',width:"100px",fontSize:"1em",margin:"12px"}}>
										<SvgIcon icon={ic_print} style={{paddingTop:"3px"}}/> FOLIO
									</Button>
								:null}

				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
				        			onClick={pantalla === 'products' ? this.onSendProduct : this.onSave}  style={{margin:12}}
									disabled={this.state.save}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
				        	</div>
				        </div>

				        <Notifications />
	        		</div>
		        </form>
		        <ModalAuth {...this.props} saving={this.saveAuth} onRef={ref => (this.modal_auth = ref)} />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalFolioSend {...this.props} onRef={ref => (this.modal_folio = ref)} socket={this.props.socket} />
				<ModalReport {...this.props} onRef={ref => (this.modal_report = ref)} socket={this.props.socket}/>
				<ModalDataSend {...this.props} onRef={ref => (this.modal_data = ref)}/>
				<ModalExpiration {...this.props} onRef={ref => (this.modal_expiration = ref)}
					saving={this.saving} />
		    </div>
		      
		)
	}
}

export default translate('translations') (UnitSend);